module.exports = __webpack_public_path__ + "img/050-coffee.88600fcd.svg";